import { Container } from "@mui/material";
import React from "react";
import { PaginaPortadaNosotrosindexAdmin } from "../../../components/Admin/Nosotros/PortadaNosotros";


export const PortadNosotrosAdmin = () => {
    return(
        <Container maxWidth='lg'>
                < PaginaPortadaNosotrosindexAdmin/>
        </Container>
    )
}